/** Marks every element that counts as "inside the layer UI" for the purposes of
 *  outside-click deselection: the canvas selection boxes, the timeline lanes,
 *  and the selected-layer control bar. */
export const LAYER_UI_ATTR = 'data-layer-ui';

/** Radix floats popovers, selects and context menus into a portal on <body>, so
 *  they are DOM-outside the layer UI even when they belong to it (the Style
 *  popover, the Speed select). Clicking one must not deselect the layer it
 *  edits. Any unrelated popper is already harmless here: opening one required
 *  clicking its trigger, which deselected the layer first. */
const RADIX_POPPER_SELECTOR = '[data-radix-popper-content-wrapper]';

/** True when a pointer event landed on layer UI. Used to decide whether a click
 *  is "outside" and should clear the layer selection.
 *
 *  Deliberately a DOM-shape query rather than a reliance on event propagation:
 *  React's synthetic `stopPropagation` inside `LayerCanvasEditor` would keep a
 *  bubble-phase document listener from ever seeing a click on a layer, which
 *  works by accident today but silently breaks the moment a handler stops
 *  calling it. Callers can listen in the capture phase and ask this instead. */
export function isLayerUiTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  if (!target.isConnected) return false;
  return Boolean(
    target.closest(`[${LAYER_UI_ATTR}]`) ?? target.closest(RADIX_POPPER_SELECTOR),
  );
}
